import { formatRating } from '../../utils/rating';
import SettingsNavItems from '../../settings/SettingsNavItems';
import StorageNavItem from '../../storage/StorageNavItem';
import { Avatar, Badge, Box, Button, Card, Chip, Divider, Drawer, IconButton, Input, LinearProgress, Link, List, ListItem, ListItemButton, listItemButtonClasses, ListItemContent, ListItemDecorator, Sheet, Stack, Tooltip, Typography } from "@mui/joy";

import ExitToAppRoundedIcon from '@mui/icons-material/ExitToAppRounded';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import CachedRoundedIcon from '@mui/icons-material/CachedRounded';
import InsertCommentRoundedIcon from '@mui/icons-material/InsertCommentRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';
import PaidRoundedIcon from '@mui/icons-material/PaidRounded';
import KeyboardArrowRightRoundedIcon from '@mui/icons-material/KeyboardArrowRightRounded';
import ContactSupportRoundedIcon from '@mui/icons-material/ContactSupportRounded';
import NotificationsIcon from '@mui/icons-material/Notifications';
import BookRoundedIcon from '@mui/icons-material/BookRounded';
import StarRoundedIcon from '@mui/icons-material/StarRounded';
import FactCheckRoundedIcon from '@mui/icons-material/FactCheckRounded';

import { useContext, useEffect, useState } from "react";
import { LayoutContext } from "../../context";
import { Link as RouterLink, useLocation, useNavigate } from "react-router";
import Cookies from "js-cookie";
import { API_URL, APIGetEvents } from "../../api";
import { useNotifications } from "../../hooks/useNotifications";
import { closeSidebar } from "../../utils";
import SwitchRoleButton from "./SwitchRoleButton";
import { hasQualitySection } from "../../cabinetAccess";




export default function SidebarDraftsman() {
    const { checkNotificationStatus, setSidebarOpen, tokenEmployee, subscribeUserToPush, totalUnread, setModalProfile, setTokenEmployee } = useContext(LayoutContext);
    const { setModalReg, setModalRate, setModalLogout } = useContext(LayoutContext);
    const { account, setAccount, setLock, setModalEvent, setListEvents, setModalTicketSupport, switchRole } = useContext(LayoutContext);

    const navigate = useNavigate();
    const location = useLocation();

    function clsBar() {
        closeSidebar();
        setSidebarOpen(false);
    }
    
    function handlerExitClick () {
        Cookies.remove("auth_token"); // Удаляем токен из cookies
        Cookies.remove("auth_token_employee");
        // Cookies.remove("active_role"); // Ужаляем токен об выборе профиля из cookies
        localStorage.removeItem('active_role');
        
        setLock(true);
        setAccount({});
        setTokenEmployee(null);
    }

    const handleDateClick = () => {
        setModalEvent({ event: null, open: true });
    };

    // Какой "state" слать?
    const stateParam = 'drawinganduser';

    // Подгружаем события
    function updateListEvents() {
        APIGetEvents(stateParam, account?.id).then((data) => {
            if (data?.length) {
                console.log("Events", data);
                setListEvents(data);
            }
        })
    }



    const [ showInstallPrompt, setShowInstallPrompt ] = useState(false);
    // Проверяем, нужно ли показывать кнопку для iOS
    useEffect(() => {
        const checkiOSRequirements = () => {
            const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
            const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
            
            if (isIOS && isSafari) {
                // Проверяем, установлено ли как PWA
                const isStandalone = window.navigator.standalone;
                const isInstalled = window.matchMedia('(display-mode: standalone)').matches;
                
                if (!isStandalone && !isInstalled) {
                    setShowInstallPrompt(true);
                }
            }
        };
        
        checkiOSRequirements();
    }, []);
    
    const handleEnableNotifications = async () => {
        if (tokenEmployee) {
            const result = await subscribeUserToPush(tokenEmployee);
            
            // Если iOS и нужно установить PWA
            if (result?.type === 'ios_need_install') {
                alert('Для получения уведомлений на iPhone:\n\n1. Нажмите кнопку "Поделиться" (в нижней панели Safari)\n2. Выберите "На экран \"Домой\""\n3. Откройте приложение с домашнего экрана');
            }
        }
    };
    
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const isStandalone = window.navigator.standalone || 
                            window.matchMedia('(display-mode: standalone)').matches;



    return (
        <>
            <Box
                className="Sidebar-overlay"
                sx={{
                    position: 'fixed',
                    zIndex: 10099,
                    top: 0,
                    left: 0,
                    width: '100vw',
                    height: '100vh',
                    opacity: '0.4',
                    backgroundColor: 'var(--joy-palette-neutral-600, #555E68)',
                    transition: 'opacity 0.4s',
                    transform: {
                        xs: 'translateX(calc(100% * (var(--SideNavigation-slideIn, 0) - 1) + var(--SideNavigation-slideIn, 0) * var(--Sidebar-width, 0px)))',
                        md: 'translateX(-100%)',
                    },
                }}
                onClick={() => clsBar()}
            />
            <Sheet
                className="Sidebar"
                sx={{
                    position: { xs: 'fixed', md: 'sticky' },
                    transform: {
                        xs: 'translateX(calc(100% * (var(--SideNavigation-slideIn, 0) - 1)))',
                        md: 'none',
                    },
                    transition: 'transform 0.4s, width 0.4s',
                    zIndex: 10100,
                    height: '-webkit-fill-available',
                    // height: '100dvh',
                    width: '240px',
                    top: 0,
                    p: 2,
                    flexShrink: 0,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 0,
                    borderRight: '1px solid',
                    borderColor: 'divider',
                }}
            >
                <Stack spacing={0} direction={"row"} sx={{ alignItems: 'flex-start', justifyContent: 'space-between' }}>
                    <Stack spacing={1} sx={{ p: 0.5 }} direction={"row"}>
                        <img style={{ width: 30 }} src="/logo191.jpg"/>
                        <Typography level="title-md">PLANIUM</Typography>
                    </Stack>
                    <Button sx={{ 
                        display: { xs: 'flex', md: 'none' }, 
                        p: 0.5 
                    }} size="sm" color="neutral" variant="plain" onClick={() => clsBar()}>
                        <CloseRoundedIcon sx={{ px: 0.4 }}/>
                    </Button>
                </Stack>
                <Stack direction={"column"} spacing={1.5} 
                    sx={{ 
                        mt: 2, 
                        minHeight: 0,
                        overflow: 'hidden auto',
                        flexGrow: 1,
                        display: 'flex',
                        flexDirection: 'column'
                    }}
                >
                    <Button onClick={updateListEvents} startDecorator={<CachedRoundedIcon/>} color="neutral" variant="soft">
                        Обновить список событий
                    </Button>
                    <Divider/>
                    
                    <List size="sm" sx={{ '--ListItem-paddingY': '0.4rem', '--List-gap': '6px', '& .MuiListItemContent-root': { minWidth: 0, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' } }}>
                        <StorageNavItem />
                    <SettingsNavItems />
                        <ListItem sx={{ borderColor: 'divider', display: 'flex', alignContent: "center", justifyContent: 'space-between' }}>
                            <ListItemButton 
                                variant="soft"
                                onClick={() => {
                                    navigate('/draftsman', { replace: true });
                                    clsBar();
                                }} 
                                color={ location.pathname == '/draftsman' ? "primary" : "neutral" }
                                sx={{ lineHeight: 1.1, px: 2, borderRadius: 'lg' }}
                            >
                                <ListItemDecorator><CalendarMonthRoundedIcon/></ListItemDecorator>
                                <ListItemContent title="События">События</ListItemContent>
                                <KeyboardArrowRightRoundedIcon/>
                            </ListItemButton>
                        </ListItem>

                        <ListItem sx={{ borderColor: 'divider', display: 'flex', alignContent: "center", justifyContent: 'space-between' }}>
                            <ListItemButton 
                                variant="soft"
                                onClick={() => {
                                    navigate('/my-payments', { replace: true });
                                    clsBar();
                                }} 
                                color={ location.pathname == '/my-payments' ? "primary" : "neutral" }
                                sx={{ lineHeight: 1.1, px: 2, borderRadius: 'lg' }}
                            >
                                <ListItemDecorator><PaidRoundedIcon/></ListItemDecorator>
                                <ListItemContent title="Мои выплаты">Мои выплаты</ListItemContent>
                                <KeyboardArrowRightRoundedIcon/>
                            </ListItemButton>
                        </ListItem>

                        {/* Контроль качества — свой раздел у мастера качества.
                            Кабинет у него общий с чертёжником, поэтому пункт
                            появляется по роли, а не по отдельному аккаунту. */}
                        {hasQualitySection(account) && (
                            <ListItem sx={{ borderColor: 'divider', display: 'flex', alignContent: "center", justifyContent: 'space-between' }}>
                                <ListItemButton
                                    variant="soft"
                                    onClick={() => {
                                        navigate('/quality', { replace: true });
                                        clsBar();
                                    }}
                                    color={ location.pathname == '/quality' ? "primary" : "neutral" }
                                    sx={{ lineHeight: 1.1, px: 2, borderRadius: 'lg' }}
                                >
                                    <ListItemDecorator><FactCheckRoundedIcon/></ListItemDecorator>
                                    <ListItemContent title="Контроль качества">Контроль качества</ListItemContent>
                                    <KeyboardArrowRightRoundedIcon/>
                                </ListItemButton>
                            </ListItem>
                        )}
                        
                        <Badge badgeContent={totalUnread} color="danger" size="sm"
                            sx={{ width: '100%',
                                "& .MuiBadge-badge": {
                                    mr: 1, mt: 1
                                }
                            }}
                        >
                            <ListItem sx={{ width: '100%', borderColor: 'divider', display: 'flex', alignContent: "center", justifyContent: 'space-between' }}>
                                <ListItemButton 
                                    variant="soft"
                                    onClick={() => {
                                        navigate('/chats', { replace: true });
                                        clsBar();
                                    }} 
                                    color={ location.pathname == '/chats' ? "primary" : "neutral" }
                                    sx={{ lineHeight: 1.1, px: 2, borderRadius: 'lg' }}
                                >
                                    <ListItemDecorator><InsertCommentRoundedIcon/></ListItemDecorator>
                                    <ListItemContent title="Чаты">Чаты</ListItemContent>
                                    <KeyboardArrowRightRoundedIcon/>
                                </ListItemButton>
                            </ListItem>
                        </Badge>

                        <ListItem sx={{ borderColor: 'divider', display: 'flex', alignContent: "center", justifyContent: 'space-between' }}>
                            <ListItemButton 
                                variant="soft"
                                onClick={() => {
                                    navigate('/knowledge', { replace: true });
                                    clsBar();
                                }} 
                                color={ location.pathname == '/knowledge' ? "primary" : "neutral" }
                                sx={{ lineHeight: 1.1, px: 2, borderRadius: 'lg' }}
                            >
                                <ListItemDecorator><BookRoundedIcon/></ListItemDecorator>
                                <ListItemContent title="База знаний">База знаний</ListItemContent>
                                <KeyboardArrowRightRoundedIcon/>
                            </ListItemButton>
                        </ListItem>
                    </List>
                </Stack>

                <Divider sx={{ mb: 1 }} />

                <Stack direction={"row"} alignItems={'center'} spacing={0.5} sx={{ width: "-webkit-fill-available", maxWidth: 200 }}>
                    <Box
                        onClick={(e) => setModalProfile(true)}
                        sx={{
                            display: 'flex', gap: 1, alignItems: 'center',
                            cursor: 'pointer',
                            p: 1, maxWidth: 190,
                            borderRadius: 'lg',
                            transition: 'background 0.15s',
                            '&:hover': { bgcolor: 'neutral.softBg' }
                        }}
                    >
                        <Avatar
                            variant="outlined"
                            size="sm"
                            src="/smile.png"
                            sx={{ 
                                p: .3,
                                "& > img": {
                                width: 25,
                                height: 'auto'
                                }
                            }}
                        />
                        <Stack sx={{ minWidth: 0, flex: 1 }} spacing={0.5}>
                            <Chip 
                                variant="soft" 
                                color="primary" 
                                endDecorator={<StarRoundedIcon sx={{ color: '#e8d221' }} />} 
                                sx={{ my: 1 }}
                            >
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <Typography level="body-sm">Рейтинг:</Typography>
                                    <Typography level="body-sm" color="primary" >
                                        {formatRating(account?.reviews?.statistics.average_rating)}
                                    </Typography>
                                </Box>
                            </Chip>

                            <Typography level="title-sm" noWrap sx={{ lineHeight: 1.1 }}>{account?.last_name} {account?.name}</Typography>
                            <Typography noWrap level="body-xs" sx={{ lineHeight: 1.1 }}>{account?.email}</Typography>
                        </Stack>
                    </Box>
                    <Stack direction="column" spacing={0.5}>
                        <SwitchRoleButton />
                        <IconButton onClick={handlerExitClick} sx={{ height: "fit-content" }} size="sm" variant="soft" color="danger">
                            <ExitToAppRoundedIcon />
                        </IconButton>
                    </Stack>
                </Stack>
            </Sheet>
        </>
    );
}